import React, { createContext, useState, useEffect, useContext } from "react";
import { useLanguages } from "../queries/use-languages";
import { usePermission } from "./PermissionContext";

const LanguageContext = createContext();

const { Provider } = LanguageContext;

const useLanguage = () => useContext(LanguageContext);

const LanguageProvider = ({ children, project }) => {
  const [displayLanguages, setDisplayLanguages] = useState(null);
  const { data: languages = [] } = useLanguages(project.id);
  const { permission } = usePermission();

  const toggleDisplayLanguage = (languageId) => {
    if (displayLanguages.includes(languageId)) {
      setDisplayLanguages(displayLanguages.filter((l) => l !== languageId));
    } else {
      setDisplayLanguages([...displayLanguages, languageId]);
    }
  };

  let allowedLanguages = languages;
  if (permission) {
    if (permission.isMember) {
      allowedLanguages = languages;
    } else if (permission.contributor) {
      const { languages: langs = [] } = permission.contributor;
      const allowedLangIds = langs.map((l) => l.languageId);
      if (allowedLangIds.length === 0) {
        allowedLanguages = languages;
      } else {
        allowedLanguages = languages.filter((d) =>
          allowedLangIds.includes(d.id)
        );
      }
    } else {
      // no permission;
    }
  }
  useEffect(() => {
    if (!displayLanguages && languages && languages.length) {
      setDisplayLanguages(languages.map((l) => l.id));
    }
  }, [displayLanguages, languages]);
  return (
    <Provider
      value={{
        languages,
        displayLanguages,
        allowedLanguages: allowedLanguages.map((l) => l.id),
        toggleDisplayLanguage,
      }}
    >
      {children}
    </Provider>
  );
};

export { LanguageProvider, useLanguage };
